import { Component, inject, Input } from '@angular/core';
import { Patient } from '../../models/patient';
import { TuiCardLarge } from '@taiga-ui/layout';
import { TraitementO2CardComponent } from './traitement-o2-card/traitement-o2-card.component';
import { TuiSurface } from '@taiga-ui/core';
import { CodeActiviteService } from '../../services/code-activite.service';
import { TraitementPpcServoVentilationCardComponent } from "./traitement-ppc-servo-ventilation-card/traitement-ppc-servo-ventilation-card.component";
import { TraitementPpcCardComponent } from "./traitement-ppc-card/traitement-ppc-card.component";
import { TraitementVniCardComponent } from "./traitement-vni-card/traitement-vni-card.component";
import { TraitementAvfCardComponent } from "./traitement-avf-card/traitement-avf-card.component";

@Component({
  selector: 'app-traitement-card',
  standalone: true,
  imports: [
    TuiCardLarge,
    TuiSurface,
    TraitementPpcCardComponent,
    TraitementPpcServoVentilationCardComponent,
    TraitementO2CardComponent,
    TraitementVniCardComponent,
    TraitementAvfCardComponent
  ],
  templateUrl: './traitement-card.component.html',
  styleUrl: './traitement-card.component.scss',
})
export class TraitementCardComponent {
  @Input() patient?: Patient;
  @Input() activite?: string;


  protected readonly codeActiviteService = inject(CodeActiviteService);

  get servoVentilation(): boolean {
    return (
      this.patient!.tableauDeBord?.materielEnlocationList?.some((m) =>
        [4403, 899, 1218, 3585, 2746].includes(m.id),
      ) ?? false
    );
  }
}
